import { Injectable } from '@angular/core'
import { BaseSiteService } from '@spartacus/core'
import { map } from 'rxjs/operators'
import { MbConstants } from '../../shared/mb-constants'

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constants = MbConstants

  constructor (protected baseSiteService: BaseSiteService) {
  }

  /**
   * Represents the isocode of the active country.
   */
  getActive () {
    return this.baseSiteService.get().pipe(
      map(active => active?.country?.isocode || this.constants.FALLBACK_COUNTRY)
    )
  }

  /**
   * Represents the name of the active country.
   */
  getActiveCountryName () {
    return this.baseSiteService.get().pipe(
      map(active => active?.country?.name || this.constants.INTERNATIONAL)
    )
  }

  /**
   * Represents the name of the active country.
   */
  getActiveCountryNameInNatLang () {
    return this.baseSiteService.get().pipe(
      map(active => active?.country?.nameNatLang || this.constants.INTERNATIONAL)
    )
  }
}
